module.exports = __webpack_public_path__ + "img/programme3.61d0662c.png";